export const ACTIVE_INGREDIENT_TTL_ES = 'Principio Activo';

export interface IActiveIngredientBase {
  description: string;
}
export interface IActiveIngredient extends IActiveIngredientBase {
  id: number;
}
export type IActiveIngredientUpdate = Partial<IActiveIngredientBase>;
